const nigeria = {

  Lagos: {
    Ikeja: [
      "Ikeja",
      "Computer Village",
      "Alausa",
      "Allen Avenue",
    ],

    Eti_Osa: [
      "Lekki",
      "Ajah",
      "Victoria Island",
      "Ikoyi",
      "Chevron",
      "Osborne",
    ],

    Surulere: [
      "Surulere",
      "Iponri",
      "Bode Thomas",
    ],

    Lagos_Island: [
      "Lagos Island",
      "Marina",
      "CMS",
      "Idumota",
    ],

    Yaba: [
      "Yaba",
      "Sabo",
      "Tejuosho",
      "Jibowu",
    ],

    Ikorodu: [
      "Ikorodu",
      "Ipakodo",
      "Owode",
    ],
  },

  // Next state starts here

Anambra: {
    Awka_South: [
      "Awka",
      "Amawbia",
      "Nibo",
      "Nise",
    ],

    Idemili_North: [
      "Ogidi",
      "Nkpor",
      "Obosi",
    ],

    Onitsha_North: [
      "Onitsha",
      "Fegge",
      "Ochanja",
    ],

    Nnewi_North: [
      "Nnewi",
      "Otolo",
      "Uruagu",
    ],
  },


  Enugu: {
    Enugu_North: [
      "Ogui",
      "New Haven",
      "Independence Layout",
    ],

    Enugu_East: [
      "Abakpa Nike",
      "Emene",
      "Trans Ekulu",
    ],

    Enugu_South: [
      "Uwani",
      "Maryland",
      "Achara Layout",
    ],

    Nsukka: [
      "Nsukka Town",
      "Obukpa",
      "Opi",
    ],
  },


  Imo: {
    Owerri_Municipal: [
      "Owerri",
      "Ikenegbu",
      "New Owerri",
    ],

    Okigwe: [
      "Okigwe",
      "Agbobu",
      "Amuro",
    ],

    Orlu: [
      "Orlu",
      "Ihioma",
      "Eziachi",
    ],
  },


  Delta: {
    Warri_South: [
      "Warri",
      "Effurun",
      "Ugborikoko",
    ],

    Oshimili_South: [
      "Asaba",
      "Okpanam",
      "Cable Point",
    ],

    Sapele: [
      "Sapele",
      "Amukpe",
      "Elume",
    ],

    Ughelli_North: [
      "Ughelli",
      "Ogor",
      "Oteri",
    ],
  },


  Edo: {
    Oredo: [
      "Benin City",
      "Ring Road",
      "GRA Benin",
    ],

    Egor: [
      "Ugbowo",
      "Egor",
      "Uselu",
    ],

    Ikpoba_Okha: [
      "Idogbo",
      "Aduwawa",
      "Oregbeni",
    ],

    Esan_West: [
      "Ekpoma",
      "Irrua",
      "Ewu",
    ],
  },


  Akwa_Ibom: {
    Uyo: [
      "Uyo",
      "Ewet",
      "Ikot Ekpene Road",
    ],

    Etinan: [
      "Etinan",
      "Ikot Akpa",
    ],

    Eket: [
      "Eket",
      "Idua",
      "Okon",
    ],
  },


  Cross_River: {
    Calabar_Municipal: [
      "Calabar",
      "Big Qua",
      "Havana",
    ],

    Ogoja: [
      "Ogoja",
      "Mbube",
    ],

    Ikom: [
      "Ikom",
      "Nde",
    ],
  },


Benue: {
    Makurdi: [
      "Makurdi",
      "Wadata",
      "North Bank",
    ],

    Gboko: [
      "Gboko",
      "Yandev",
      "Tarka",
    ],

    Otukpo: [
      "Otukpo",
      "Adoka",
      "Apa",
    ],
  },


  Plateau: {
    Jos_North: [
      "Jos",
      "Tudun Wada",
      "Terminus",
    ],

    Jos_South: [
      "Rayfield",
      "Bukuru",
      "Vom",
    ],

    Bassa: [
      "Bassa",
      "Miango",
    ],

    Pankshin: [
      "Pankshin",
      "Chip",
    ],
  },


  

Borno: {
    Maiduguri: [
      "Maiduguri",
      "Baga Road",
      "GRA Maiduguri",
    ],

    Jere: [
      "Jere",
      "Dikwa Road",
    ],

    Biu: [
      "Biu",
      "Dugja",
    ],
  },


  Yobe: {
    Damaturu: [
      "Damaturu",
      "Nayinawa",
    ],

    Potiskum: [
      "Potiskum",
      "Dawasa",
    ],

    Nguru: [
      "Nguru",
      "Hausari",
    ],
  },


  Bauchi: {
    Bauchi: [
      "Bauchi",
      "Yelwa",
      "Fadaman Mada",
    ],

    Azare: [
      "Azare",
      "Madara",
    ],

    Misau: [
      "Misau",
      "Gwaram",
    ],
  },


  Gombe: {
    Gombe: [
      "Gombe",
      "Pantami",
      "Tumfure",
    ],

    Kaltungo: [
      "Kaltungo",
      "Tula",
    ],

    Billiri: [
      "Billiri",
      "Talasse",
    ],
  },


  Adamawa: {
    Yola_North: [
      "Yola",
      "Jimeta",
      "Doubeli",
    ],

    Mubi_North: [
      "Mubi",
      "Digil",
    ],

    Numan: [
      "Numan",
      "Vulpi",
    ],
  },


  Taraba: {
    Jalingo: [
      "Jalingo",
      "Kona",
    ],

    Wukari: [
      "Wukari",
      "Hospital Road",
    ],

    Bali: [
      "Bali",
      "Garba Chede",
    ],
  },


  Jigawa: {
    Dutse: [
      "Dutse",
      "Sakwaya",
    ],

    Hadejia: [
      "Hadejia",
      "Gagulmari",
    ],

    Gumel: [
      "Gumel",
      "Danzomo",
    ],
  },


  Sokoto: {
    Sokoto_North: [
      "Sokoto",
      "Arkilla",
      "Gagi",
    ],

    Tambuwal: [
      "Tambuwal",
      "Dogon Daji",
    ],

    Wurno: [
      "Wurno",
      "Achida",
    ],
  },


  Kebbi: {
    Birnin_Kebbi: [
      "Birnin Kebbi",
      "Badariya",
    ],

    Argungu: [
      "Argungu",
      "Alwasa",
    ],

    Yauri: [
      "Yauri",
      "Garin Yauri",
    ],
  },


  Zamfara: {
    Gusau: [
      "Gusau",
      "Tudun Wada",
    ],

    Kaura_Namoda: [
      "Kaura Namoda",
      "Kwanar Magaji",
    ],

    Talata_Mafara: [
      "Talata Mafara",
      "Moriki",
    ],
  },


Kaduna: {
    Kaduna_North: [
      "Kaduna",
      "Kawo",
      "Ungwan Rimi",
    ],

    Kaduna_South: [
      "Barnawa",
      "Television",
      "Tudun Wada",
    ],

    Zaria: [
      "Zaria",
      "Sabon Gari",
      "Tudun Wada Zaria",
    ],

    Kafanchan: [
      "Kafanchan",
      "Kagarko",
    ],
  },


  Kano: {
    Fagge: [
      "Fagge",
      "Sabon Gari",
      "Kofar Mata",
    ],

    Dala: [
      "Dala",
      "Kurna",
      "Gobirawa",
    ],

    Nassarawa: [
      "Nassarawa",
      "Bompai",
      "Hotoro",
    ],

    Tarauni: [
      "Tarauni",
      "Gyadi Gyadi",
    ],
  },


  Katsina: {
    Katsina: [
      "Katsina",
      "Kofar Sauri",
      "Kofar Marusa",
    ],

    Funtua: [
      "Funtua",
      "Dandume",
    ],

    Daura: [
      "Daura",
      "Baure",
    ],
  },


  Abia: {
    Umuahia_North: [
      "Umuahia",
      "Afugiri",
      "Ibeku",
    ],

    Aba_North: [
      "Aba",
      "Ariaria",
      "Osisioma",
    ],

    Aba_South: [
      "Eziama",
      "Ngwa Road",
    ],

    Ohafia: [
      "Ohafia",
      "Abiriba",
    ],
  },


  Ebonyi: {
    Abakaliki: [
      "Abakaliki",
      "Nkaliki",
      "Kpirikpiri",
    ],

    Afikpo_North: [
      "Afikpo",
      "Ehugbo",
    ],

    Ezza_South: [
      "Onueke",
      "Ezza",
    ],
  },


  Bayelsa: {
    Yenagoa: [
      "Yenagoa",
      "Kpansia",
      "Amassama",
    ],

    Southern_Ijaw: [
      "Oporoma",
      "Amatolo",
    ],

    Brass: [
      "Brass",
      "Twon Brass",
    ],
  },

Nasarawa: {
    Lafia: [
      "Lafia",
      "Shabu",
      "Bukan Sidi",
    ],

    Karu: [
      "Mararaba",
      "New Nyanya",
      "Karu Town",
    ],

    Keffi: [
      "Keffi",
      "Angwan Iya",
    ],
  },


  Niger: {
    Minna: [
      "Minna",
      "Tunga",
      "Kpakungu",
    ],

    Suleja: [
      "Suleja",
      "Madalla",
      "Gauraka",
    ],

    Bida: [
      "Bida",
      "Kutigi",
      "Lemu",
    ],
  },


  Kogi: {
    Lokoja: [
      "Lokoja",
      "Ganaja",
      "Adankolo",
    ],

    Okene: [
      "Okene",
      "Obangede",
    ],

    Kabba: [
      "Kabba",
      "Otu",
    ],

    Idah: [
      "Idah",
      "Ejule",
    ],
  },


  Kwara: {
    Ilorin_West: [
      "Ilorin",
      "Adewole",
      "Oko Erin",
    ],

    Ilorin_East: [
      "Oke Oyi",
      "GRA Ilorin",
    ],

    Offa: [
      "Offa",
      "Ojoku",
    ],

    Jebba: [
      "Jebba",
      "Bode Saadu",
    ],
  },


  Osun: {
    Osogbo: [
      "Osogbo",
      "Oke Baale",
      "Alekuwodo",
    ],

    Ife_East: [
      "Ile-Ife",
      "Modakeke",
    ],

    Ilesa: [
      "Ilesa",
      "Iperindo",
    ],

    Ede: [
      "Ede",
      "Oja Timi",
    ],
  },


  Ogun: {
    Abeokuta_South: [
      "Abeokuta",
      "Kuto",
      "Lafenwa",
    ],

    Ado_Odo_Ota: [
      "Ota",
      "Ifo",
      "Ilaro",
    ],

    Sagamu: [
      "Sagamu",
      "Makun",
    ],

    Ijebu_Ode: [
      "Ijebu Ode",
      "Odo Egbo",
    ],
  },


  Ekiti: {
    Ado_Ekiti: [
      "Ado Ekiti",
      "Basiri",
      "Ajilosun",
    ],

    Ikere: [
      "Ikere Ekiti",
      "Oke Ori Omi",
    ],

    Ikole: [
      "Ikole Ekiti",
      "Odo Ado",
    ],
  },

Ondo: {
    Akure_South: [
      "Akure",
      "Alagbaka",
      "Oke Aro",
    ],

    Akure_North: [
      "Akure",
      "Oba Ile",
      "Isinkan",
    ],

    Ondo_West: [
      "Ondo Town",
      "Lijoka",
      "Yaba",
    ],

    Owo: [
      "Owo",
      "Emure",
      "Uso",
    ],

    Idanre: [
      "Idanre",
      "Owena",
    ],
  },


  Oyo: {
    Ibadan_North: [
      "Ibadan",
      "Bodija",
      "Agodi",
    ],

    Ibadan_South_West: [
      "Ring Road",
      "Oluyole",
      "Apata",
    ],

    Ibadan_North_West: [
      "Dugbe",
      "Iyaganku",
      "Mokola",
    ],

    Ogbomoso_North: [
      "Ogbomoso",
      "Arowomole",
    ],

    Oyo_East: [
      "Oyo Town",
      "Atiba",
      "Akeetan",
    ],

    Iseyin: [
      "Iseyin",
      "Ado Awaye",
    ],

    Eruwa: [
      "Eruwa",
      "Lanlate",
    ],
  },

FCT_Abuja: {
    Abuja_Municipal: [
      "Garki",
      "Wuse",
      "Maitama",
      "Asokoro",
      "Central Business District",
    ],

    Bwari: [
      "Kubwa",
      "Bwari Town",
      "Dutse Alhaji",
    ],

    Gwagwalada: [
      "Gwagwalada",
      "Zuba",
      "Dobi",
    ],

    Kuje: [
      "Kuje",
      "Kwali",
      "Chukuku",
    ],

    Abaji: [
      "Abaji",
      "Yaba",
      "Nuku",
    ],

    Kwali: [
      "Kwali",
      "Pai",
      "Yangoji",
    ],
  },

};

export default nigeria;